<script setup lang="ts">
import { defineProps, defineEmits, ref, watch } from 'vue';
import useGlobalStateStore from "@/Store/GlobalStateStore";

const props = defineProps({ Title: String, Summary: String, ImagePath: String });
const emit = defineEmits(['openModal']);

enum Enum_Theme { Dark, Light }
const GlobalStyleStore = useGlobalStateStore();
const handleClick = () => emit('openModal');

const ThemeTitleText = ref("#FFF");
const ThemeTitleTextHover = ref("#57E1D9");
const ThemeContentText = ref("#cecece");

watch(GlobalStyleStore, () => {
  if (GlobalStyleStore.CurrentTheme === Enum_Theme.Dark){
    ThemeTitleText.value='#FFF'; ThemeTitleTextHover.value='#57E1D9'; ThemeContentText.value='#cecece';
  } else {
    ThemeTitleText.value='#545454'; ThemeTitleTextHover.value='#f77373'; ThemeContentText.value='#484848';
  }
}, { immediate: true });
</script>

<template>
  <div class="InfoBoxBG" @click="handleClick">
    <div class="InfoBoxContainer">
      <div class="Info_Text">
        <div class="TitleText">{{ props.Title }}</div>
        <div class="PartingLine"></div>
        <div class="ContentText">{{ props.Summary || '点击查看详情...' }}</div>
      </div>
      <div class="Info_Image">
        <div class="InfoImage_Content">
          <img :src="props.ImagePath" alt="Cover">
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.InfoBoxBG{ width: 100%; display: flex; align-items: center; justify-content: center; margin: 0 0 60px 0; cursor: pointer; }
.InfoBoxContainer { display: grid; width: 60%; grid-template-areas: "Info_Text Info_Image"; grid-template-columns: 1.5fr 1fr; justify-content: flex-end; align-items: center; }
@media screen and (max-width: 1200px) { .InfoBoxContainer { grid-template-columns: 1.5fr 1fr; } }
@media screen and (max-width: 768px) { .InfoBoxContainer { grid-template-columns: 1.7fr 1.2fr; } }
@media screen and (max-width: 425px) { .InfoBoxContainer { grid-template-columns: 1fr 0; } }
.Info_Text { grid-area: Info_Text; display: flex; flex-direction: column; padding-right: 20px;}
.Info_Image { grid-area: Info_Image; }
.TitleText{ font-size: 2.2rem; font-family: 资源圆体, sans-serif; font-weight: bold; color: v-bind(ThemeTitleText); transition: 0.3s; }
.InfoBoxBG:hover .TitleText { color: v-bind(ThemeTitleTextHover); }
.PartingLine{ background-color: v-bind(ThemeTitleTextHover); height: 6px; width: 15%; border-radius: 10px; margin: 10px 0 15px 0; }
.ContentText{ font-family: 资源圆体, sans-serif; color: v-bind(ThemeContentText); line-height: 1.6; font-size: 1.05rem;}
.InfoImage_Content img { width: 320px; height: 180px; object-fit: cover; border-radius: 10px; float: right; box-shadow: 0 8px 20px rgba(0,0,0,0.2); transition: 0.4s; }
.InfoBoxBG:hover .InfoImage_Content img { transform: translateY(-5px) scale(1.02); }
@media screen and (max-width: 768px) { .InfoImage_Content img  { width: 180px; height: 100px; } .TitleText{ font-size: 1.6rem; } }
@media screen and (max-width: 425px) { .InfoImage_Content img  { display: none; } }
</style>
